import { render, staticRenderFns } from "./marketingBasicSet.vue?vue&type=template&id=55cacc70&scoped=true&"
import script from "./marketingBasicSet.vue?vue&type=script&lang=js&"
export * from "./marketingBasicSet.vue?vue&type=script&lang=js&"
import style0 from "./marketingBasicSet.vue?vue&type=style&index=0&id=55cacc70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cacc70",
  null
  
)

export default component.exports